import React, { useEffect, useState } from "react";
import styles from './AddAccountUser.module.scss';
import { useDispatch } from "react-redux";
import {
    getPermissionsByRole
} from "../../store/data-slice";
import { $t } from "../../helpers/translator";
import api from "../../helpers/api";
import _ from "lodash";
import MultiSelectWithValidation from "../miscellaneous/MultiSelectWithValidation/MultiSelectWithValidation";
import InputWithValidation from "../miscellaneous/InputWithValidation/InputWithValidation";
import { setAlert } from "../../store/alerts-slice";
import { $validate } from "../../helpers/formValidator";
import { getUser } from "../../store/auth-slice";

const AddAccountUser = (props) => {
    const dispatch = useDispatch();

    const [ formSent, setFormSent ] = useState(false);
    const [ loading, setLoading ] = useState(true);

    const [ formError, setFormError ] = useState('');

    const [ passwordValidationKey, setPasswordValidationKey ] = useState(0);
    const [ inputsKey, setInputsKey ] = useState(0);


    const [ values, setValues ] = useState({
        name: { errors: [], value: "" },
        email: { errors: [], value: "" },
        password: { errors: [], value: "" },
        passwordValidation: { errors: [], value: "" },
        subRole: { errors: [], value: "" },
        personalId: { errors: [], value: "" },
    });

    const [ valueRules, setValueRules ] = useState({
        name: [ 'required', 'minLength(3)' ],
        email: [ 'required', 'email' ],
        password: [ 'required', 'password' ],
        passwordValidation: [ 'required', 'match()' ],
        subRole: [ 'required' ],
        personalId: [ 'required', 'minLength(5)', 'maxLength(30)', 'id' ],
    });

    const [ subRoleOptions, setSubRoleOptions ] = useState([]);

    const doInit = async () => {
        let user = await dispatch(getUser());
        let role = user.role;
        let subRoles = await dispatch(getPermissionsByRole(role));

        let subRolesArray = [];
        _.forEach(subRoles, (v, k) => {
            subRolesArray.push(v);
        })

        if (props.user) {
            // console.log('user passed: ', props.user)
            let updatedValues = { ...values };
            // updatedValues.name.value = props.user.name;
            // updatedValues.email.value = props.user.email;

            let subRoleIndex = _.findIndex(subRolesArray, function (o) {
                return o.value === props.user.sub_role;
            });
            updatedValues.subRole.value = subRolesArray[ subRoleIndex ];
            updatedValues.personalId.value = props.user.personal_id;
            setValues(updatedValues)
            setInputsKey(inputsKey + 2);
        }

        setSubRoleOptions(subRolesArray);
        setLoading(false);
    }

    useEffect(() => {
        doInit();
    }, []);

    useEffect(async () => {
        let updatedValueRules = { ...valueRules };
        updatedValueRules.passwordValidation = [ 'required', `match(${values.password.value})` ];
        setValueRules(updatedValueRules);

        setPasswordValidationKey(passwordValidationKey + 1);
    }, [ values.password ]);


    function fieldChangeHandler(fieldName, updatedValue) {
        // console.log('handler', fieldName, updatedValue);
        let updatedValues = { ...values };
        if(fieldName === 'subRole') {
            const subRole = updatedValue.value.value;
            if(subRole === 'staff') {
                setValueRules({
                    ...valueRules,
                    personalId: [ 'required', 'minLength(5)', 'maxLength(30)', 'id' ],
                })
            } else {
                setValueRules({
                    ...valueRules,
                    personalId: [],
                })
            }
            
        }
        updatedValues[ fieldName ] = updatedValue;
        setValues(updatedValues)
    }

    async function formSentClickHandler() {
        setFormError('');
        setFormSent(true);
        let errors = validate();
        // console.log('errors', errors)
        console.log(errors)
        if (errors.length) {
            setFormError($t('global.account.errorsFound'));
            return;
        }

        if (props.user) {
            let payload = {
                sub_role: values.subRole.value.value,
                personal_id: values.personalId.value,
            }

            try {
                let res = await api.patch(`user/${props.user.id}`, payload);
                // console.log('>>>>>res:', res);
                if (res && res.success && res.data && res.data.success) {
                    dispatch(setAlert({ type: 'success' }))
                    props.onSuccess();
                    return;
                }

                dispatch(setAlert({ type: 'error' }))
                setFormError(res.errorText)
            } catch (e) {
                dispatch(setAlert({ type: 'error' }))
            }
        } else {
            let payload = {
                name: values.name.value,
                email: values.email.value,
                password: values.password.value,
                sub_role: values.subRole.value.value,
                personal_id: values.personalId.value,
            }
            try {
                let res = await api.post('user', payload);
                // console.log('>>>>>res:', res);
                if (res && res.success && res.data && res.data.success) {
                    dispatch(setAlert({ type: 'success' }))
                    props.onSuccess();
                    return;
                }
                dispatch(setAlert({ type: 'error' }))
                setFormError(res.errorText)
            } catch (e) {
                dispatch(setAlert({ type: 'error' }))
            }
        }

    }

    function validate() {
        let errors = [];

        if (props.user) {
            const fieldsToTest = [ 'subRole', 'personalId' ];
            
            _.forEach(values, (v, k) => {
                if(fieldsToTest.includes(k)) {
                    const value = v.value === null ? '' : v.value;
                    errors = errors.concat($validate(value, valueRules[ k ]));
                }
            })
        } else {
            // console.log('add')
            _.forEach(values, (v, k) => {
                // console.log(k, v, 'errors', $validate(v.value, valueRules[k]));
                errors = errors.concat($validate(v.value, valueRules[ k ]));
            })
        }

        return errors;
    }

    return (
        <>
            { loading ?
                null
                :
                <div>
                    <div className={ styles.header }>
                        <h3>{ (props.user ? $t('global.account.editAccountUser') : $t('global.account.addAccountUser')) }</h3>
                    </div>
                    <div className={ 'alma-box-content' }>
                        <div className={ 'alma-fields-section' } style={ {
                            padding: '15px 0',
                            marginBottom: 15
                        } }>
                            { props.user ?
                                <div>
                                    <div >
                                        <div>User's details can be edited by the user himself on account page</div>
                                    </div>
                                </div>
                                :
                                <div >
                                    <div>Users you add will be able to access your account.</div>
                                    <div>The role selected will impact their permissions.</div>
                                </div>
                            }

                        </div>
                        { !props.user ?
                            <div className={ 'alma-fields-section' }>
                                <div className={ 'alma-fields-row' }>
                                    <div className={ 'alma-field-container' }>
                                        <div className={ 'alma-field-header' }>{ $t('global.account.name') }</div>
                                        <InputWithValidation
                                            name="name"
                                            validations={ valueRules.name }
                                            onChange={ (data) => fieldChangeHandler('name', data) }
                                            touched={ formSent }
                                            type="text"
                                            value={ values.name }
                                        // key={inputsKey}
                                        />
                                    </div>

                                    <div className={ 'alma-field-container' }>
                                        <div className={ 'alma-field-header' }>{ $t('global.account.email') }</div>
                                        <InputWithValidation
                                            name="email"
                                            validations={ valueRules.email }
                                            onChange={ (data) => fieldChangeHandler('email', data) }
                                            touched={ formSent }
                                            type="text"
                                            value={ values.email }
                                        // key={inputsKey}
                                        />
                                    </div>
                                </div>


                                <div className={ 'alma-fields-row' }>
                                    <div className={ 'alma-field-container' }>
                                        <div className={ 'alma-field-header' }>{ $t('global.account.password') }</div>
                                        <InputWithValidation
                                            name="password"
                                            validations={ valueRules.password }
                                            onChange={ (data) => fieldChangeHandler('password', data) }
                                            touched={ formSent }
                                            type="password"
                                            value={ values.password }
                                        />
                                    </div>

                                    <div className={ 'alma-field-container' } style={ { maxWidth: '100%' } }>
                                        <div
                                            className={ 'alma-field-header' }>{ $t('global.account.passwordValidation') }</div>
                                        <InputWithValidation
                                            name="passwordValidation"
                                            validations={ valueRules.passwordValidation }
                                            onChange={ (data) => fieldChangeHandler('passwordValidation', data) }
                                            touched={ formSent }
                                            type="password"
                                            value={ values.passwordValidation }
                                            validateNow={ passwordValidationKey }
                                        />
                                    </div>
                                </div>
                            </div>
                            :
                            null
                        }

                        <div className={ 'alma-fields-row' }>
                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.account.subRole') }</div>
                                <MultiSelectWithValidation
                                    required
                                    options={ subRoleOptions }
                                    selected={ values.subRole.value }
                                    onValueChange={ (data) => fieldChangeHandler('subRole', data) }
                                    touched={ formSent }
                                />
                            </div>
                            { values.subRole.value.name === 'staff' && <>
                                <div className={ 'alma-field-container' }>
                                    <div className={ 'alma-field-header' }>{ $t('global.staff.personalId') }</div>
                                    <InputWithValidation
                                        required
                                        validations={ valueRules.personalId }
                                        onChange={ (data) => fieldChangeHandler('personalId', data) }
                                        touched={ formSent }
                                        value={ values.personalId }
                                    />
                                </div>
                            </> }
                        </div>


                    </div>

                    <div className={ 'alma-box-footer' }>
                        <div className={ styles.formError }>{ formError }</div>
                        <div className={ 'alma-button' } onClick={ async () => await formSentClickHandler() }>
                            { $t('global.account.save') }
                        </div>
                    </div>
                </div>
            }
        </>
    )
}


export default AddAccountUser;
